import { MinswapWidget } from './MinswapWidget';

export default MinswapWidget;
